import http from "../http-common";
import authHeader from './auth-header';

class decodeService {

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PERIODS

  decodeEmailToken(token) {
    return http.post(`/decode_email_token/${token}`, { headers: authHeader() });
  }

  decodeUserToken(token) {
    return http.post(`/decode_user_token/${token}`, { headers: authHeader() });
  }
}

export default new decodeService();